<main>
	<div id="myCarousel" class="carousel slide {{classCarousel}}" data-bs-ride="carousel">
		<div class="carousel-inner">
			<div class="carousel-item active">
				<img [src]="imagen">
				<div class="container">
					<div class="carousel-caption text-start" [style]="styleCaption">
						<h1 [innerHtml]="h1"></h1>
						<img [src]="logo" *ngIf="logo !== ''">

						<p [innerHtml]="p"></p>
						<ul *ngIf="lista.length > 0">
							<li *ngFor="let opcion of lista;">{{ opcion }}</li>
						</ul>

						<a class="btn btn-lg btn-primary boton-mypath" *ngIf="logo !== ''" href="mailto:care@manpowergroup.com.mx">Contáctanos</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</main>